const columnTranslations = {
	Answer: 'Antwort',
	AnsweredDate: 'Beantwortungsdatum',
	CaseState: 'Fall Status',
	City: 'Stadt',
	Company: 'Unternehmen',
	CreatedDate: 'Erstellungsdatum',
	DeactivatedDate: 'Deaktivierungsdatum',
	DecidedDate: 'Entscheidungsdatum',
	DecisionState: 'Status EntscheIdung',
	Email: 'E-Mail',
	ExternalNote: 'Externe Notiz',
	Firstname: 'Vorname',
	FirstValidDate: 'Erstes Gültigkeitsdatum',
	Gender: 'Geschlecht',
	Hid: 'Hid',
	Initials: 'Initialien',
	InternalNote: 'Interne Notiz',
	LastValidDate: 'Letztes Gültigkeitsdatum',
	Lastname: 'Nachname',
	Message: 'Nachricht',
	Name: 'Name',
	NotResponsibleReason: 'Begründung: Nicht verantwortlich',
	Phone: 'Telefonnummer',
	PostalCode: 'Postleitzahl',
	PreVoteEndDate: 'Senatsentscheidung: Enddatum',
	PreVoteStartDate: 'Senatsentscheidung: Startdatum',
	PublishedDate: 'Veröffentlichungsdatum',
	Question: 'Frage',
	ReasonText: 'Begründungstext',
	Seal: 'Pro-Ethik-Siegel',
	Shared: 'Geteilt',
	State: 'Status',
	Status: 'Status',
	Street: 'Straße',
	Text: 'Text',
	Title: 'Titel',
	TitleAfter: 'Titel (nach)',
	TitleBefore: 'Titel (vor)',
	Type: 'Typ',
	UpdatedDate: 'Aktualisierungsdatum',
	ValidToDate: 'Gültigkeitsdatum',
	VoteEndDate: 'Werberatsentscheidung: Enddatum',
	VoteStartDate: 'Werberatsentscheidung: Startdatum',
	Cases: 'Fälle',
	Complaints: 'Beschwerden',
	Decisions: 'Entscheidungen',
	Files: 'Dateien',
	Links: 'Links',
	Statements: 'Stellungnahmen',
	Callbacks: 'Rückfragen',
	Emails: 'E-Mails',
	PreVoteRoleId: 'Senatsgruppen',
	PreVoteRoles: 'Senatsgruppen',
	VoteRoleId: 'Werberatgruppen',
	VoteRoles: 'Werberatgruppen',
	Mediums: 'Mediums',
	Sectors: 'Branchen',
	Reaches: 'Reichweiten',
	OpenAiResults: 'KI-Vorschläge',
	CategoryId: 'Kategorien',
	CaseId: 'Fall',
	Case: 'Fall',
	ComplaintId: 'Beschwerde',
	Complaint: 'Beschwerde',
	StatementsDate: 'Abschluss Senatsentscheidung',
};

const filteredTerms = [
	'ConcurrencyStamp',
	'CreatedUserId',
	'UpdatedUserId',
	'TwoFactorEnabled',
	'NormalizedEmail',
	'NormalizedUserName',
	'IsContact',
	'IsUser',
	'EmailConfirmed',
	'AccessFailedCount',
	'LockoutEnabled',
	'PhoneNumberConfirmed',
	'SecurityStamp',
	'PasswordHash',
	'LastLogin',
];

export const translateAffectedColumns = (affectedColumns) => {
	let translations = affectedColumns.map((column) => {
		return columnTranslations[column] || column;
	});

	translations = translations.filter((column) => !filteredTerms.includes(column));

	return translations;
};
